import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@constants/routePaths';
import { useNotification } from '@providers/NotificationProviders';
import { getSessionMessage } from '@utils/sessionMessage';
import { Spin } from 'antd';
import { jwtDecode } from 'jwt-decode';
import { TokenPayload } from '@src/interfaces/costcoDashboard.interface';

const CostcoCallback = () => {
  const navigate = useNavigate();
  const openNotification = useNotification();
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const error = urlParams.get('error');
  const hasNotificationBeenShown = useRef(false);

  useEffect(() => {
    if (error === '400') {
      navigate('/not-authorized', { replace: true });
      return;
    }

    if (token) {
      try {
        const decoded = jwtDecode<TokenPayload>(token);

        const { pageType } = decoded;

        if (pageType === 'Admin') {
          localStorage.setItem('costcoAdminToken', token);
          navigate(ROUTES.COSTCO_DASHBOARD, { replace: true });
        } else if (pageType === 'Verification') {
          localStorage.setItem('costcoVerificationToken', token);
          navigate(ROUTES.MEMBER_VERIFICATION, { replace: true });
        } else {
          console.error('Unknown pageType:', pageType);
          navigate('/not-authorized', { replace: true });
        }

        if (!hasNotificationBeenShown.current) {
          openNotification(getSessionMessage(token), 'Success');
          hasNotificationBeenShown.current = true;
        }

      } catch (err) {
        console.error('Failed to decode token:', err);
        navigate('/not-authorized', { replace: true });
      }
    } else {
      console.error('No token found in the callback URL');
      navigate('/not-authorized', { replace: true });
    }
  }, [token, error, navigate, openNotification]);

  return <Spin size="large" />;
};

export default CostcoCallback;
